import { useState } from 'react';
import { House, Package, Tag } from 'shared/icons';
import PromotionsByItem from '../components/campaigns/PromotionsByItem';
import PromotionsList from '../components/campaigns/PromotionsList';
import PageHeader from '../components/layout/PageHeader';
import PromotionsItems from './PromotionsItems';

const Promotions = () => {
    const [activeTab, setActiveTab] = useState('items');

    const tabs = [
        { id: 'items', label: 'Itens em Campanhas', icon: House },
        { id: 'campaigns', label: 'Campanhas', icon: Tag },
        { id: 'by-item', label: 'Campanhas por Item', icon: Package },
    ];

    return (
        <div className="space-y-6">
            <PageHeader title="Promocoes" subtitle="Gerencie campanhas e acompanhe itens promocionais" />

            <div className="rounded-xl border border-mono-200 bg-white p-6 dark:border-mono-800 dark:bg-mono-950">
                <div className="mb-6 border-b border-mono-200 dark:border-mono-800">
                    <div className="flex gap-1 overflow-x-auto">
                        {tabs.map((tab) => {
                            const Icon = tab.icon;
                            const isActive = activeTab === tab.id;
                            return (
                                <button
                                    key={tab.id}
                                    type="button"
                                    onClick={() => setActiveTab(tab.id)}
                                    className={`inline-flex items-center gap-2 border-b-2 px-4 py-3 text-sm font-medium transition-colors ${
                                        isActive
                                            ? 'border-black text-black dark:border-white dark:text-white'
                                            : 'border-transparent text-mono-500 hover:text-mono-700 dark:text-mono-400 dark:hover:text-mono-200'
                                    }`}
                                >
                                    <Icon size={16} />
                                    {tab.label}
                                </button>
                            );
                        })}
                    </div>
                </div>

                {activeTab === 'campaigns' ? <PromotionsList /> : null}
                {activeTab === 'by-item' ? <PromotionsByItem /> : null}
                {activeTab === 'items' ? <PromotionsItems /> : null}
            </div>
        </div>
    );
};

export default Promotions;
